import mergeobj from '../extraUtil/mergeTwoObj';
let chart = {
    "lowerlimit": "0",
    "upperlimit": "5",
    "showtickmarks":"0",
    "showtickvalues":"0",
    "targetColor": "#70ae6e",
    "plotFillColor":"#6B7FD7",
    "plotfillalpha":"80",
    "showvalue":"0",
    "valuefontsize":"30",
    "valueFontColor":"#247BA0",
    "chartBottomMargin":"0",
    "chartLeftMargin":"20",
    "chartRightMargin":"10",
    "chartTopMargin":"0",
    "valuefontbold":"1",
    "numberPrefix": "$"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme, allShipperData) {
    chart = mergeobj(chart, theme);
    let dataSource = {},
        data = [],
        billRatePerMile = 0,
        billCount = rawData.length,
        grossBillRatePerMile = 0,
        grossBillCount = allShipperData.length;
    for (let i = 0; i < rawData.length; i++) {
        if (rawData[i]['billableRatePerMiles']) {
            billRatePerMile += parseFloat(rawData[i]['billableRatePerMiles']);
        } else {
            billCount--;
        }
    }
    for (let i = 0; i < allShipperData.length; i++) {
        let shipper = allShipperData[i]['shipper'];
        if (allShipperData[i]['billableRatePerMiles'] && (shipper !== 'Greenway Carriers')) {
            grossBillRatePerMile += parseFloat(allShipperData[i]['billableRatePerMiles']);
        } else {
            grossBillCount--;
        }
    }
    billRatePerMile /= billCount;
    grossBillRatePerMile /= grossBillCount;
    data.push({
        "label": "Greenway Carries",
        "value": billRatePerMile
    });
    data.push({
        "label": "Industry",
        "value": grossBillRatePerMile
    });
    dataSource = {
        chart: chart,
        value: billRatePerMile,
        target: grossBillRatePerMile
    }
    return dataSource;
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/billRateGenerator.js